<template>
  <section v-scroll-nav="{ path: '/about/why' }" class="about">
    <SectionExplanation>
      <template v-slot:title>
        <div v-animate-in="{ delay: 0 }">{{ $t('about-why-title') }}</div>
      </template>
      <template v-slot:headline>
        <div v-animate-in="{ delay: 0.15 }">{{ $t('about-why-headline') }}</div>
      </template>
      <template v-slot:body>
        <div v-animate-in="{ delay: 0.25 }">{{ $t('about-why-details') }}</div>
      </template>
      <template v-slot:image>
        <mq-layout mq="tb+" class="tab">
          <img :src="section.why" />
        </mq-layout>
      </template>
    </SectionExplanation>
  </section>
</template>

<script>
import SectionExplanation from '@/components/common/SectionExplanation';
import section from '@/assets/data/about/section';

export default {
  name: 'Why',
  data() {
    return {
      section
    };
  },
  components: {
    SectionExplanation
  }
};
</script>

<style lang="scss" scoped>
.about {
  /deep/ .explanation {
    .headline {
      color: $col-blue-light;
    }
  }
}
</style>
